// A small badge for a card whose thread is "To reply" or "Awaiting reply" (reply tracking). One
// list request feeds every card, mapped by thread key; nothing is fetched per card.
import { useThreadReplyStatus } from "@web/lib/tasksQueries";
import { REPLY_BADGE, replyWaitingLabel } from "@web/tasks/wording";

export function ReplyBadge({ threadKey }: { threadKey: string | null }) {
  const status = useThreadReplyStatus(threadKey);
  const label = status ? REPLY_BADGE[status.status] : undefined;
  if (!status || !label) return null;
  return (
    <span
      className="shrink-0 rounded-full border border-line px-2 text-[11px] leading-5 text-ink-2"
      title={status.status === "awaiting_reply" ? replyWaitingLabel(status) : status.reason}
      data-testid="reply-badge"
    >
      {label}
    </span>
  );
}
